import BaseAPI from './base/base-api';

class DictionaryAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'PaymentAPI';
	controllerName = 'dictionary';
}

export default new DictionaryAPI();
